<template>
  <div>
    <Row type="flex" justify="start" ref="cardgroup" class="cardgroup">
      <Col style="margin-top:30px;" v-for="(item,index) in newQyList" :key="index" :style="{'margin-left':marginLeft}">
        <dragger :drag-target="item" :drag-data="item.unionId">
          <Card :padding="0" style="width: 280px;height:360px">
            <div
              class="card-wrapper"
              @mouseover="cardHover(index)"
              @mouseout="cardOut(index)"
              @click="gotoDetail(item.id,item.status)"
            >
              
              <div
                
                class="iconfont icon-chushaixuanxiang icon-cha"
                v-show="item.showCha"
                @click.stop="clickCha(item,index)"
              ></div>
              <Checkbox v-if="item.status == 2" v-model="item.isSelect" @click.native.stop="handleClickCheck" class="checkbox"></Checkbox>
              <div class="imgbox">
                <div class="img">
                  <img v-if="item.headPicUrl" :src="item.headPicUrl">
                  <img v-else src="./qy.png">
                  <div class="authstate" :class="authClass(item.status)">
              
                    {{ item.status === '' ? '未提交' : item.status==1?'审核通过':(item.status===0?'审核未通过':'待审核')}}
                  </div>
                </div>
              </div>
              <div class="pname slh" :title="item.companyName">{{ item.name}}</div>
              <div class="from-wrapper box">
                <div class="from" v-if="item.shijian">
                  <span class="iconfont icon-shijianbanli icon-shijian"></span>
                  <span>事件办理</span>
                </div>
                <div class="from" v-if="item.party">
                  <span class="iconfont icon-dangzhibugongzuo icon-zhibu"></span>
                  <span>党支部</span>
                </div>
                <div class="from" v-if="item.shenghuo">
                  <span class="iconfont icon-jiazhengfuwu icon-shenghuo"></span>
                  <span>生活服务</span>
                </div>
              </div>
              <div class="service-wrapper box" v-if="item.service.length">
                <div
                  v-for="(child,index) in item.service"
                  :key="index"
                  v-if="index < 3"
                  class="service-item box_f1 slh"
                  :title="child.name"
                >
                  <img :src="child.url" class="service-pic">
                  <div class="slh">{{child.name}}</div>
                </div>
              </div>
            </div>
          </Card>
        </dragger>
      </Col>
    </Row>
  </div>
</template>

<script>
import dragger from "../../../components/dragger/drag";
var that;
export default {
  name: "sqfwCard",
  components: {
    dragger
  },
  props: {
    spinShows: Boolean,
    QyList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      showDel: false,
      delType: [], //要删除的管理员包含的社区类型
      delList: [], //要删除的类型
      delAdminId: "",
      newQyList: [],
      cardItemWidth: 280, // 设为0 可动态获取 宽度
      marginLeft: "",
    };
  },
  watch: {
    QyList() {
      //  没有初始化时执行
      if (!this.cardItemWidth) {
        // 有数据时执行
        if (this.$refs.cardgroup.$children.length > 0) {
          this.cardItemWidth = this.$refs.cardgroup.$children[0].$el.clientWidth;
          this.getMargin();
        }
      }
      var old = that.QyList;
      old.forEach(item => {
        var list = item.companyTypeList ? item.companyTypeList : [];
        list.forEach(sub => {
          
          if (sub.propertyType == "company_type_event") {
            item.shijian = 1;
          } else if (sub.propertyType == "company_type_party") {
            item.party = 1;
          } else if (sub.propertyType == "company_type_service") {
            item.shenghuo = 1;
          }
        });
      });
      that.newQyList = old.map(item => {
        item.isSelect = false
        return item
      });
      // console.log(that.newQyList)
    }
  },
  methods: {
    handleClickCheck() {

    },
    getMargin() {
      this.$nextTick()
        .then(() => {
          if (this.$refs.cardgroup) {
            let boxWidth = this.$refs.cardgroup.$el.clientWidth;
            let count = Math.floor(boxWidth / this.cardItemWidth) + 1;
            let rest = boxWidth % this.cardItemWidth;
            this.marginLeft = rest / count + "px";
          }
        })
        .catch(e => console.log(e));
    },
    cardHover(index) {
      that.QyList[index].showCha = true;
    },
    cardOut(index) {
      that.QyList[index].showCha = false;
    },
    clickCha(item, index) {
      this.$emit("delQy", item.id);
      // var url = that.urlobj.delQy(item.id);
      // that
      //   .$delete(url)
      //   .then(res => {
      //     if (res.isSucceed) {
      //       that.$Message.success("删除成功");
      //       that.$emit("delQy", index);
      //     } else {
      //       this.$Message.error(res.message);
      //     }
      //   })
      //   .catch(e => {});
    },
    gotoDetail(id, status) {
      this.$router.push({ name: "qiyeDetail", query: { companyId: id, status } });
    },
    authClass: function(state) {
      return {
        verified: state == 1,
        verifying: state == 2,
        noVerify: state == 0
      };
    },
  },
  created() {
    that = this;
  },
  mounted() {
    this.getMargin();
    window.onresize = this.getMargin;
  }
};
</script>

<style scoped>
.imgbox {
  width: 100%;
}
.img {
  padding: 45px 0 30px 100px;
}
.img img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.pname {
  text-align: center;
  font-size: 16px;
  color: #666666;
  padding: 0 20px 55px 20px;
  border-bottom: 1px solid #eee;
}
.from-wrapper {
  padding: 30px 20px 0 20px;
  align-items: center;
  justify-content: center;
}
.from {
  text-align: center;
  padding-bottom: 5px;
  margin-right: 5px;
}
.form:last-child {
  margin-right: 0;
}
.card-wrapper {
  color: #4b4b4b;
  position: relative;
}
.icon-shijian {
  padding-right: 5px;
  color: #0496f9;
  font-size: 14px;
}
.icon-shenghuo {
  padding-right: 5px;
  color: #87a7d6;
  font-size: 14px;
}
.icon-zhibu {
  padding-right: 5px;
  color: #ff5543;
}
.icon-cha {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #cdcdcd;
  font-size: 20px;
}
.del-wrapper {
  height: 340px;
  display: flex;
  flex-wrap: wrap;
}
.delItem-wrapper {
  height: 150px;
  width: 120px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  text-align: center;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}
.type-icon {
  margin-bottom: 20px;
}
.xuanzhong {
  position: absolute;
  top: -10px;
  right: -10px;
  height: 20px;
  width: 20px;
}
.isselect {
  border: 2px solid #ff7b44;
}
.service-wrapper {
  background: #f9f9f9;
  padding: 7px 0;
  align-items: center;
  margin: 0 10px;
  border-radius: 4px;
}
.service-pic {
  height: 16px;
  width: 16px;
  margin-right: 5px;
}
.service-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.authstate {
  position: absolute;
  left: 100px;
  top: 115px;
  width: 82px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
}
/* 认证状态 */
.verified {
  background-color: #47ba54;
}
.verifying {
  background-color: #ff7744;
}
.noVerify {
  background-color: #a1afb3;
}
.checkbox{
  position:absolute;
  left: 10px;
  top: 10px;
}
</style>
